import { Alert } from 'react-bootstrap';

const FormErrorAlert = ({ errors = [] }) => {
  if (!errors.length) return null;

  return (
    <Alert variant="danger">
      <ul className="mb-0">
        {errors.map((error, i) => (
          <li key={i}>{error}</li>
        ))}
      </ul>
    </Alert>
  );
};

export default FormErrorAlert;